import axios from 'axios';
import { normalize } from 'normalizr';

import { flow, pick, get } from 'lodash/fp';

import { selectSelectedUser } from 'Root/modules/users/selectors';
import { userTypes } from 'Root/modules/users';

import { toDoTypes } from './../todos';

import { toDoListSchema } from './schema';

import * as types from './types';

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

export function toDoListsFetchByUserId({ userId }) {
  return dispatch => dispatch({
    type: types.TODOLISTS_FETCH,
    async payload() {
      const response = await axios.get(`/api/v1/user/${userId}/todolists/`);
      const normalized = normalize(response.data, [toDoListSchema]);
      const { toDoLists, users, toDos } = normalized.entities;

      await Promise.all([
        dispatch({
          type: types.TODOLISTS_MERGE,
          payload: toDoLists,
        }),
        dispatch({
          type: userTypes.USERS_MERGE,
          payload: users,
        }),
        dispatch({
          type: toDoTypes.TODOS_MERGE,
          payload: toDos,
        }),
      ]);
    },
  });
}

export function toDoListCreate({ title }) {
  return (dispatch, getState) => {
    const selectedUser = selectSelectedUser(getState());
    const data = {
      title,
      owner: selectedUser.id,
    };

    return dispatch({
      type: types.TODOLIST_CREATE,
      payload: {
        async promise() {
          const response = await axios.post('/api/v1/todolist/', data);
          const normalized = normalize(response.data, toDoListSchema);
          const { toDoLists } = normalized.entities;
          return toDoLists;
        },
        data,
      },
    });
  };
}

export function toDoListChange({ toDoListId, data }) {
  return {
    type: types.TODOLIST_CHANGE,
    payload: data,
    meta: {
      toDoListId,
    },
  };
}

export function toDoListSave({ toDoListId }) {
  return (dispatch, getState) => {
    const data = flow(
      get('toDoLists'),
      get(toDoListId),
      pick(['title']),
    )(getState());

    dispatch({
      type: types.TODOLIST_SAVE,
      payload: {
        async promise() {
          const response = await axios.patch(`/api/v1/todolist/${toDoListId}/`, data);
          const normalized = normalize(response.data, [toDoListSchema]);
          const { toDoLists } = normalized.entities;
          return toDoLists;
        },
      },
      meta: {
        toDoListId,
      },
    });
  };
}

export function selectToDoList({ toDoListId }) {
  return {
    type: types.TODOLIST_SELECT,
    meta: {
      toDoListId,
    },
  };
}
